import React from 'react';
import Toast from '../UI/Toast';

interface MainLayoutProps {
  children: React.ReactNode;
  isLoading?: boolean;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children, isLoading = false }) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-white">
        <div className="animate-spin w-16 h-16">
          <img
            src="/svg/fruit-strawberry-pink.svg"
            alt="Ladeanzeige"
            loading="lazy"
            className="w-full h-full object-contain"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <div id="toast-container">
        <Toast />
      </div>

      <main className="flex-grow pb-24">{children}</main>

    </div>
  );
};

export default MainLayout;
